import { createReducer, on } from '@ngrx/store';

import { IState } from '../model';
import { initialState } from './state';
import {
  loadAIUMCReleaseNotesStart,
  loadAIUMCReleaseNotesFailed,
  loadAIUMCReleaseNotesCompleted,
  selectReleaseNote,
  createReleaseNote,
  resetAIUMCReleaseNoteState,
  setTriggerSaveApiInDoc,
  setProcessingStateOnUMCAPI,
  setCurrentSelectedAIUMCNotes,
  removeAIUMCReleaseNote,
} from './actions';

const loadingState = {
  processing: false,
  failed: false,
  completed: false,
};

export const reducer = createReducer(
  initialState,
  on(loadAIUMCReleaseNotesStart, (state: IState) => ({
    ...state,
    ...loadingState,
    processing: true,
  })),
  on(loadAIUMCReleaseNotesFailed, () => ({
    ...initialState,
    ...loadingState,
    failed: true,
  })),
  on(loadAIUMCReleaseNotesCompleted, (state: IState, { notes }) => ({
    ...state,
    ...loadingState,
    completed: true,
    notes: [...state.notes, ...notes],
  })),
  on(selectReleaseNote, (state: IState, { note }) => ({
    ...state,
    note,
  })),
  on(createReleaseNote, (state: IState, { isCreating }) => ({
    ...state,
    isCreating,
  })),
  on(
    resetAIUMCReleaseNoteState,
    (state: IState, { notes, note, isCreating }) => ({
      ...state,
      notes,
      note,
      isCreating,
      currentSelectedAIUMCNotes: [],
    })
  ),
  on(
    setTriggerSaveApiInDoc,
    (state: IState, { triggerSaveApiInDoc, payloadForUMCPostDocSave }) => ({
      ...state,
      triggerSaveApiInDoc,
      payloadForUMCPostDocSave,
    })
  ),
  on(setProcessingStateOnUMCAPI, (state: IState) => ({
    ...state,
    processing: true,
  })),
  on(
    setCurrentSelectedAIUMCNotes,
    (state: IState, { currentSelectedAIUMCNotes }) => ({
      ...state,
      currentSelectedAIUMCNotes,
    })
  ),
  on(removeAIUMCReleaseNote, (state: IState, { notes }) => ({
    ...state,
    notes,
  }))
);
